import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";
import { type ComponentProps, forwardRef, useState } from "react";

export interface PasswordInputProps extends ComponentProps<typeof Input> {
  /** data-testid tlačítka pro zobrazení/skrytí hodnoty. */
  toggleTestId?: string | undefined;
}

/**
 * Input pro tajné hodnoty (hesla, API klíče) s tlačítkem zobrazit/skrýt.
 * Obaluje shadcn Input; feature-specifické `data-testid` přepínače dodá
 * volající (auth má vlastní wrapper v features/auth).
 */
export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, toggleTestId, ...props }, ref) => {
    const [visible, setVisible] = useState(false);

    return (
      <div className="relative">
        <Input type={visible ? "text" : "password"} ref={ref} className={className} {...props} />
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="absolute right-0 top-0 h-full px-3 hover:bg-transparent"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? "Skrýt hodnotu" : "Zobrazit hodnotu"}
          data-testid={toggleTestId}
          tabIndex={-1}
        >
          {visible ? (
            <EyeOff className="h-4 w-4 text-muted-foreground" />
          ) : (
            <Eye className="h-4 w-4 text-muted-foreground" />
          )}
        </Button>
      </div>
    );
  },
);
